import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { FC, useState } from 'react';

import { Checkbox } from 'components/Checkbox';
import { useStore } from 'hooks/useStore';

import { Promo } from './Promo';

import css from './MobileAppChannelCheckBox.module.css';

const MobileAppChannelCheckBox: FC = () => {
  const {
    app: { i18n },
    mobileDevices,
    savedFilters: { popup },
  } = useStore();

  const [isAppPromoVisible, setIsAppPromoVisible] = useState<boolean>(false);

  if (!popup) return null;

  const handleLinkClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setIsAppPromoVisible(!isAppPromoVisible);
  };

  const link = (
    <button
      className={cn(css.link, 'glz-link glz-is-medium glz-is-pseudo', {
        ['glz-has-text-dark-gray']: !isAppPromoVisible,
      })}
      onClick={handleLinkClick}
    >
      {i18n.filterPopup.inApp}
    </button>
  );

  return (
    <div className={css.app}>
      {isAppPromoVisible && <Promo />}

      <Checkbox
        checked={popup.channels.app.value}
        disabled={
          mobileDevices.availableDevices?.availableChannels.length === 0 ||
          (popup.channels.app.value && popup.channels.isOneChannelSelected)
        }
        tooltip={
          popup.channels.app.value && popup.channels.isOneChannelSelected && i18n.subscriptions.channels.disabledTooltip
        }
        onChange={popup.channels.app.setValueFromCheckbox}
      >
        {link}
      </Checkbox>
    </div>
  );
};

const connected = observer(MobileAppChannelCheckBox);

export { connected as MobileAppChannelCheckBox };
